/** The gateway's hosted checkout, in a new tab so the dialog keeps polling. */
export function openPaymentPage(url: string | null) {
  if (url) window.open(url, '_blank', 'noopener,noreferrer')
}
